import type {Idioma} from '@cnc/contracts';
import {createContext, useContext} from 'react';

// El idioma activo y como cambiarlo (lo provee ProveedorDeIdioma).
export type ContextoDeIdioma = {idioma: Idioma; cambiar: (idioma: Idioma) => void};

export const ContextoIdioma = createContext<ContextoDeIdioma>({idioma: 'es', cambiar: () => undefined});

export const useIdioma = () => useContext(ContextoIdioma);
